import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../../Request";
import {endLoading, startLoading} from "../../../../store/slices/loadingSlice";
import requestMiddlewares from "../../../requestMiddlewares";
import {GetSelectedCompany} from "../../../../utils/selectCompany";

export default async function (
  dispatch: Dispatch,
  filters?: any,
): Promise<IResponse> {
  const cid = GetSelectedCompany();
  if (!cid) {
    return {
      statusCode: 500,
      data: {
        message: 'No company selected'
      }
    }
  }

  const request = new RACARequest('companyTalent', 'pendingCount')
    .setPathValues('COMPANY_ID', cid)
    .setQueryParameters(filters || {})

  const response = await request.makeRequest();
  requestMiddlewares(
    dispatch,
    response,
  );

  return response;
}
